import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";
import logo from "../images/logo.png";

const Footer = () => {
  return (
    <div className="contact-container">
      <h3 className="contact-title">Linectでつなぐ、LINEで広がる。</h3>
      <p className="contact-title1">LINE運用はLinectにお任せ！</p>
      <p className="contact-sab">
        まずはお気軽にご相談・お問い合わせください。
      </p>

      <div className="slider-button-container">
        <Link to="/download" className="slider-button1">
          資料をダウンロードする
        </Link>
        <Link to="/Inquiry" className="slider-button2">
          問い合わせをする
        </Link>
      </div>

      <footer className="footer">
        <div className="footer-content">
          <img src={logo} alt="ValueOne Logo" className="footer-logo" />
          <div className="footer-links">
            <a href="#company-overview">会社情報</a>
            <Link to="/privacy-policy">プライバシーポリシー</Link>
          </div>
        </div>
        <p className="footer-rights">
          © 2024 ITLIT Co., Ltd. All Rights Reserved.
        </p>
      </footer>
    </div>
  );
};

export default Footer;
